import { Link } from 'react-router-dom';
import { HelpCircle, MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

/** FAQ and Support — standalone header links (not in the Services menu). */
export default function PublicFaqSupportLinks({ className }: { className?: string }) {
  const linkClass =
    'text-gray-600 hover:text-emerald-600 transition-colors font-medium flex items-center text-sm sm:text-base min-h-[44px] min-w-[44px] justify-center px-2 py-2 rounded-md';

  return (
    <div className={cn('flex items-center', className)}>
      <Link to="/faq" className={linkClass} aria-label="Frequently Asked Questions">
        <MessageCircle className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
        <span className="hidden sm:inline">FAQ</span>
      </Link>
      <Link to="/support" className={linkClass} aria-label="Support Center">
        <HelpCircle className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
        <span className="hidden sm:inline">Support</span>
      </Link>
    </div>
  );
}
